import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

interface HeaderProps {
  title: string;
  description?: string;
  /** Page-level actions, rendered on the right, or under the title when there is no room. */
  children?: React.ReactNode;
}

/**
 * Page header. Insight puts breadcrumbs here; this panel is flat — four pages, no
 * nesting — so the title carries the same slot instead.
 *
 * The actions wrap under the title on a narrow screen rather than squeezing it into a column a
 * few words wide. A gap rather than margins, so the wrapped row starts where the title does.
 */
const Header: React.FC<HeaderProps> = ({ title, description, children }) => {
  return (
    <Stack direction='row' sx={headerStackStyles} spacing={2} useFlexGap>
      <Stack sx={{ flex: '1 1 18rem', minWidth: 0 }}>
        <Typography variant='h5' sx={{ fontWeight: 600 }}>{title}</Typography>
        {description && (
          <Typography variant='body2' sx={{ color: 'text.secondary', mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Stack>
      <Stack direction='row' sx={{ gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
        {children}
      </Stack>
    </Stack>
  );
};

const headerStackStyles = {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  rowGap: 1,
  paddingTop: 4.5,
  paddingBottom: '26px',
};

export default Header;
